// extracted by mini-css-extract-plugin
export var button = "Testimonial-module--button--17233";
export var buttonActive = "Testimonial-module--button-active--f1d2d";
export var buttonImg = "Testimonial-module--button-img--bc3c2";
export var buttonImgActive = "Testimonial-module--button-img-active--59380";
export var icon = "Testimonial-module--icon--96a10";
export var iconActive = "Testimonial-module--icon-active--8e241";
export var narrow = "Testimonial-module--narrow--3da5a";